import React from 'react'
import Header from '../../component/Header'
import AboutUs from '../AboutUs'
import Footer from '../../component/Footer'

export default function LayoutAboutUs() {
    return (
        <div>
            <Header />
            <AboutUs />
            <Footer />
        </div>
    )
}
